import React from "react";

import { RAILS_PACKS_URL } from "config/globals";
import waitForScript, { defaultLoader } from "lib/utils/waitForScript";
import { generateUuid } from "lib/utils/socialtravel";
const CURRENT_COMPANY_ID_CACHE_KEY = `socialtravel-partnerapp-${APP_ENV}/auth/company.id`;
export const COMPANY_ID = window.localStorage.getItem(CURRENT_COMPANY_ID_CACHE_KEY);
import { APP_ENV } from "config/globals";

export const WIDGET_SCRIPT_URL = RAILS_PACKS_URL + "/widgetv2.js?v=" + ~~(new Date().getTime() / 1000 / 60);
const stagingJSCode = APP_ENV === "staging" || APP_ENV === "staging-aws" ? `window.__st.staging=true;` : "";

export const widgetJsCode = `<!-- Tripsomnia JS widget -->
<script type="text/javascript">
  window.__st = window.__st || {};
  window.__st.company_id = "${COMPANY_ID}";
  ${stagingJSCode}
  (function() {
    var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
    var cacheId = ~~((new Date()).getTime() / 1000 / 60);
    lc.src = '${RAILS_PACKS_URL}/widgetv3.js?company_id=${COMPANY_ID}&cacheId=' + cacheId;
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
  })();
</script>
`;

export const oldwidgetJsCode = `<!-- Tripsomnia JS widget -->
<script type="text/javascript">
  window.__st = window.__st || {};
  (function() {
    var lc = document.createElement('script'); lc.type = 'text/javascript'; lc.async = true;
    var cacheId = ~~((new Date()).getTime() / 1000 / 60);
    lc.src = '${RAILS_PACKS_URL}/widgetv2.js?v=' + cacheId;
    var s = document.getElementsByTagName('script')[0]; s.parentNode.insertBefore(lc, s);
  })();
</script>
`;

export const iframeCode = ({ url, width, height }) =>
  `<iframe src="${url}" width="${width}" height="${height}" frameborder="0"></iframe>`;
export const widgetComponentCode = ({ component, ...props }) =>
  `<span class='__stComponent' data-component='${component.toLowerCase()}'></span>`;

@waitForScript(WIDGET_SCRIPT_URL)
export default class StWidget extends React.PureComponent {
  mountWidget(ref) {
    const {
      widgetProps: { component, ...props },
    } = this.props;
    if (!window.__stWidget) {
      console.error("window.__stWidget is unavailable! StWidget impossible to render.");
      return;
    }

    if (this._componentElement && this._componentNode) {
      try {
        window.__stWidget.unmountComponentAtNode(this._componentElement, this._componentNode);
      } catch (e) {
        console.error("Error while trying to unmount previous __stWidget component: " + e.toString());
      }
      delete this._componentElement;
      delete this._componentNode;
    }

    try {
      if (ref) {
        this._componentElement = ref;
        this._componentNode = window.__stWidget.mountComponent(ref, component, props);
      }
    } catch (e) {
      console.error("Error while rendering __stWidget: " + e.toString());
    }
  }

  render() {
    const { widgetProps } = this.props;
    const uuid = generateUuid();
    return (
      <div id={`StWidget-${uuid}`} key={uuid} ref={(ref) => this.mountWidget(ref)}>
        {defaultLoader}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/settings/WidgetsSettingsView/StWidget.jsx